(()=>{'use strict';
const settings=JSON.parse(document.getElementById('MaisonCartSettings').textContent);
document.addEventListener('submit',async event=>{
  const form=event.target;
  if(!form.matches('.product-form,.sanadil-form')||event.defaultPrevented)return;
  event.preventDefault();
  if(form.dataset.cartPending==='true'||!form.reportValidity())return;
  const button=form.querySelector('[data-add-button],[data-sanadil-add]');
  if(!button||button.disabled)return;
  const preorder=event.submitter?.hasAttribute('data-preorder');
  const status=form.querySelector('[data-variant-status]');
  const values=new FormData(form),id=Number(values.get('id')),quantity=Number(values.get('quantity')||1),properties={};
  if(!id||!Number.isInteger(quantity)||quantity<1)return;
  for(const [key,value] of values){const match=key.match(/^properties\[(.+)\]$/);if(match&&typeof value==='string'&&value!=='')properties[match[1]]=value;}
  const items=[{id,quantity,properties}],box=form.querySelector('[data-garment-options]'),toggle=box?.querySelector('[data-pants-toggle]');
  if(toggle?.checked){
    const strings=JSON.parse(box.querySelector('[data-garment-strings]').textContent);
    properties._tenue=crypto.randomUUID();
    const extras=Object.fromEntries(Object.entries(properties).filter(([key])=>!key.includes('(cm)')&&key!=='Prise de mesures'));
    extras[strings.associated]=box.dataset.productTitle;
    form.querySelectorAll('[data-option-index]').forEach(option=>{extras[option.dataset.optionName||strings.color]=option.value;});
    items.push({id:Number(toggle.dataset.variant),quantity,parent_id:id,properties:extras});
  }
  const controls=[...form.querySelectorAll('button,input,select,textarea')],states=controls.map(control=>control.disabled);
  form.dataset.cartPending='true';form.setAttribute('aria-busy','true');controls.forEach(control=>control.disabled=true);status.textContent=settings.adding;
  let added=false;
  try{
    const response=await fetch(settings.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!response.ok){const error=await response.json().catch(()=>({}));throw Error(error.description||settings.error);}
    added=true;
    if(preorder){window.location.assign(settings.cart);return;}
    status.textContent=settings.added;form.querySelector('[data-cart-view]').hidden=false;
    try{
      const response=await fetch(settings.root+'cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}});
      if(response.ok){const cart=await response.json();document.querySelectorAll('[data-cart-count]').forEach(count=>{count.textContent=cart.item_count;count.closest('a')?.setAttribute('aria-label',settings.label.replace('__COUNT__',cart.item_count));});}
    }catch{}
  }catch(error){status.textContent=error.message||settings.error;}
  finally{if(!preorder||!added){controls.forEach((control,i)=>control.disabled=states[i]);form.dataset.cartPending='false';form.removeAttribute('aria-busy');}}
});
})();
